<script>
import BackgroundHalfCircle from '@/components/BackgroundHalfCircle'
import ImageTile from '@/components/ImageTile'
import ViewTitle from '@/components/ViewTitle'
import Checkbox from '@/components/Checkbox'
import DOMUtils from '@/utils/DOMUtils'
import EventsUtils from '@/utils/eventsUtils'
import Date from '@/utils/dateUtils'
import EnvironmentUtils from '@/utils/environmentUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import ActualitiesServices from '@/services/actualities'
import urljoin from 'url-join'

const REF_TILES_CONTAINER = 'tiles-container'

export default
{
    name: 'actualities',

    created ()
    {
        ActualitiesServices.fetchActualities(EnvironmentUtils.cityId, null, {from: 0, to: 10, excludeContent: true}).then(async actualities =>
        {
           await this.$store.commit('actualities/updateActualityList', actualities)

            console.log('Setting actualities seen to all available actualities id')
            LocalStorageUtils.actualitiesSeen = this.$store.state.actualities.actualityList.map(a => a.id)
        })
    },

    render () 
    {
        return (
            <div id='actualities-view'>
                <BackgroundHalfCircle settings-mobile={{ height: '30vh' }} settings-tablet={{ height: '20vh' }} settings-desktop={{ height: '10vh' }} />
                <view-title>Actualités</view-title>
                <checkbox label='Être notifié des nouvelles actualités' v-model={this.$store.state.user.tags.notifiedOnNewActuality}
                    on-click={() => this.$store.commit('user/saveTags')} />
                <div id='tiles-container' ref={REF_TILES_CONTAINER}>
                    {this.$store.state.actualities.actualityList.map(actuality =>
                    {
                        if (actuality.isDraft) return undefined
                        
                        return this.createActualityCard(h, actuality, (e, tile) => this.onActualityCardClick(e, tile, actuality.id))
                    })}
                </div>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    beforeRouteEnter (to, from, next)
    {
        next(vm =>
        {
            document.addEventListener('scroll', vm.onScrollEvent)

            let tilesContainer = vm.$refs[REF_TILES_CONTAINER];
            
            if (LocalStorageUtils.useIntensiveAnimations)
            {
                let tiles = tilesContainer.querySelectorAll('.image-tile')
                
                let delay = 0;

                tiles.forEach(tile =>
                {
                    tile.style.visibility = 'hidden'
                    setTimeout(() =>
                    {
                        tile.style.visibility = 'visible'
                        DOMUtils.animateCSS(tile, 'zoomIn', '0.5s')
                    }, delay)

                    delay += 100;
                })
            }
            else
            {
                tilesContainer.style.transition = 'none'
                tilesContainer.style.opacity = 0
                setTimeout(() =>
                {
                    tilesContainer.style.transition = 'opacity 0.3s linear'
                    tilesContainer.style.opacity = 1
                }, 100)
            }
        })
    }, 

    beforeRouteLeave (to, from, next)
    {
        document.removeEventListener('scroll', this.onScrollEvent)
        
        next()
    },

    methods:
    {
        createActualityCard (h, actuality, onClick)
        {
            return <ImageTile on-click={onClick} title={actuality.title}
                            date={Date.dateToString(actuality.date, 'iso', 'fr')} description={actuality.description}
                            background-image={urljoin(actuality.imageUrl, '?width=500') } />
        },

        onActualityCardClick (e, tile, actualityId)
        {
            this.$router.push({path: `${actualityId}`, append: true, query: { whileFetchingImage: tile.backgroundImage }})
        },

        onScrollEvent: EventsUtils.debounce(async () =>
        {
            if (DOMUtils.getScrollDistanceFromDocumentBottom() < 300)
            {
                let actualityList = app.$store.state.actualities.actualityList
                let actualities = await ActualitiesServices.fetchActualities(EnvironmentUtils.cityId, {from: actualityList.length, number: 5})

                app.$store.commit('actualities/updateActualityList', actualities)
            }
        }, 200)
    },

    computed:
    {
        tilesContainer ()
        {
            return this.$refs[REF_TILES_CONTAINER]
        }
    },

    components:
    {
        ViewTitle,
        ImageTile,
        BackgroundHalfCircle,
        Checkbox
    }
}
</script>

<style lang='less' scoped>
@import '~@/styles/main.less';

#actualities-view
{
    margin: 2% 6%;
    margin-bottom: 12vh;

    .OnTablet({
        margin: 2% 15%
    });

    .OnDesktop({
        margin: 2% 1.5%;
        margin-top: 5vw;
        margin-bottom: unset;
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
    });

    .view-title
    {
        color: white;
    }

    #tiles-container
    {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20px;

        .OnTabletAndLess({
            flex-direction: column;
        });

        .image-tile
        {
            margin: 4% 0%;

            &:first-of-type
            {
                margin-top: 0;
            }

            .OnTablet({
                margin: 3% 0%;
            });
            
            .OnDesktop({
                margin: 1% 2%;
                width: 40%;
            });
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Actualities.vue